/**
 * Copyright 2026, CS GROUP, https://www.cs-soprasteria.com/
 *
 * This file is part of AntFlow project.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { LatLngBounds } from 'leaflet';

export class BBOXUtils {
  static parseBBoxString(bboxString: string): number[] | null {
    try {
      const trimmed = bboxString.trim();
      const parsed = JSON.parse(trimmed);
      if (!Array.isArray(parsed)) {
        return null;
      }
      const bbox = parsed.map((val) => {
        const num = Number(val);
        if (isNaN(num)) {
          throw new Error(`Invalid number: ${val}`);
        }
        return num;
      });
      if (bbox.length !== 4) {
        throw new Error(`Invalid bbox length: ${bbox.length}`);
      }
      return bbox;
    } catch (e) {
      console.error('Failed to parse bbox string:', e);
      return null;
    }
  }
  static boundsToArray(bounds: LatLngBounds, precision = 7): number[] {
    return bounds
      .toBBoxString()
      .split(',')
      .map((el) => parseFloat(parseFloat(el).toFixed(precision)));
  }

  static arrayToLatLngBounds(value: number[]): LatLngBounds | undefined {
    if (this.isValidBBox(value)) {
      return new LatLngBounds({ lat: value[1], lng: value[0] }, { lat: value[3], lng: value[2] });
    }
  }

  static isValidBBox(bbox?: number[]): boolean {
    return Array.isArray(bbox) && bbox.length === 4 && bbox.every((el) => !!el);
  }
}
